<template>
  <div class="st-graph-pro">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$Slope = Velocity (v)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>当前位移 s</label>
            <span class="val">{{ s.toFixed(1) }} <small>m</small></span>
          </div>
          <div class="hud-item orange">
            <label>斜率 (速度 v)</label>
            <span class="val">{{ velocity.toFixed(1) }} <small>m/s</small></span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 坐标轴 -->
          <g stroke="#334155" stroke-width="1.5">
             <line x1="50" y1="200" x2="400" y2="200" /> <!-- t axis -->
             <line x1="50" y1="40" x2="50" y2="200" />  <!-- s axis -->
          </g>
          <text x="400" y="215" fill="#64748b" font-size="10">时间 t</text>
          <text x="30" y="45" fill="#64748b" font-size="10">位移 s</text>

          <!-- 实时运动轨迹 (s-t) -->
          <path :d="stPath" fill="none" stroke="#06b6d4" stroke-width="3" />
          <circle :cx="timeToX(elapsedTime)" :cy="sToY(s)" r="5" fill="#fbbf24" />
          
          <!-- 辅助切线 (展示斜率即速度) -->
          <line :x1="timeToX(elapsedTime)-30" :y1="sToY(s) + velocity*5" 
                :x2="timeToX(elapsedTime)+30" :y2="sToY(s) - velocity*5" 
                stroke="#f43f5e" stroke-width="2" stroke-dasharray="4,2" />
        </svg>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节运动速度 (即图像斜率)：{{ velocity }} m/s</label>
                 <el-slider v-model="velocity" :min="-10" :max="10" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="primary" size="small" @click="toggleAnim">{{ isRunning ? '停止' : '开始运动' }}</el-button>
                 <el-button size="small" @click="reset">重置</el-button>
              </div>
           </div>
        </div>
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-odometer"></i>
           <p><strong>核心规律：</strong>在 $s-t$ 图像中，**切线的斜率** 代表物体的运动速度。<strong>观察：</strong>调节正向速度，直线向上倾斜；数值越大，倾角越陡。这直观展示了位置变化率的几何本质。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'ST_GraphViz',
  data() {
    return {
      velocity: 2,
      elapsedTime: 0,
      s: 0,
      pathPoints: [],
      isRunning: false
    }
  },
  computed: {
    stPath() {
       if (this.pathPoints.length < 2) return "";
       let p = `M ${this.timeToX(this.pathPoints[0].t)},${this.sToY(this.pathPoints[0].s)}`;
       this.pathPoints.forEach(pt => {
          p += ` L ${this.timeToX(pt.t)},${this.sToY(pt.s)}`;
       });
       return p;
    }
  },
  methods: {
    toggleAnim() { this.isRunning = !this.isRunning; if(this.isRunning) this.animate(); },
    animate() {
       if (!this.isRunning) return;
       this.elapsedTime += 0.05;
       this.s += this.velocity * 0.05;
       this.pathPoints.push({ t: this.elapsedTime, s: this.s });
       if (this.elapsedTime > 20) this.reset();
       requestAnimationFrame(this.animate);
    },
    reset() {
       this.elapsedTime = 0; this.s = 0; this.pathPoints = []; this.isRunning = false;
    },
    timeToX(t) { return 50 + t * 15; },
    sToY(s) { return 150 - s * 8; }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.st-graph-pro { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
